module.exports = __webpack_public_path__ + "static/5a42e049.v5_banner1.png";